import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import {
    pcaa
} from 'area-data';
import store from '../store';
import {
    Message
} from 'element-ui';

// 登录状态信息加密key
const loginInfoKey = 'bc0877996b8a4d2a87695b314dcc9263';

/**
 * 数字转填充0的字符串
 * @param {*} value
 */
const toDoubleString = (value) => {
    if (value < 10 && value >= 0) {
        return `0${value}`;
    }
    return value.toString();
};

/**
 * 验证手机号
 * @param {*} phone
 */
const validatePhone = (phone) => {
    if (!phone) {
        return false;
    }
    return /^1((3[0-9])|(4[1579])|(5[0-9])|(6[6])|(7[0-9])|(8[0-9])|(9[0-9]))\d{8}$/.test(phone);
};

/**
 * 保存登录状态
 *
 * @param {*} data
 */
/**
 *
 *
 * @param {*} data
 */
const saveloginInfo = (data) => {
    const edcodedPassword = CryptoJS.AES.encrypt(data.Password, loginInfoKey).toString();
    const obj = {
        Phone: data.Phone,
        Password: edcodedPassword
    };
    const objStr = JSON.stringify(obj);
    Cookies.set('ce_loginInfo', objStr);
};

/**
 * 获取保存的登录信息
 */
const getloginInfo = () => {
    const str = Cookies.get('ce_loginInfo');
    if (str) {
        return JSON.parse(str);
    }
    return undefined;
};

/**
 * 密码解码
 * @param {*} value
 */
const decodePassword = (value) => {
    return CryptoJS.AES.decrypt(value, loginInfoKey).toString(CryptoJS.enc.Utf8);
};

/**
 * 显示提示
 *
 * @param {*} flag
 * @param {*} msg
 * @param {*} [type=null]
 * @param {number} [duration=0]
 */
const showMsg = (flag, msg, type = null, duration = 0) => {
    type = type || (flag ? 'success' : 'error');
    Message({
        message: msg,
        type,
        duration: duration > 0 ? duration : 3 * 1000,
        showClose: true
    });
};

/**
 * 成功提示
 *
 * @param {*} msg
 * @param {number} [duration=0]
 */
const showOk = (msg, duration = 0) => {
    showMsg(true, msg, 'success', duration);
};
/**
 * 错误提示
 *
 * @param {*} msg
 * @param {number} [duration=0]
 */
const showError = (msg, duration = 0) => {
    showMsg(false, msg, 'error', duration);
};

/**
 * 获取当前加盟商的area-select数据
 */
const filterProvince = () => {
    const provinceObj = pcaa['86'];
    const tempObj = {};
    const currentProvince = store.state.shop.currentProvince;
    if (currentProvince) {
        for (const key in provinceObj) {
            if (currentProvince.some(a => a.Code === key)) {
                tempObj[key] = provinceObj[key];
            }
        }
    }
    pcaa['86'] = tempObj;
    console.log('filterProvince -> pcaa', pcaa);
    return pcaa;
};

// 克隆
const clone = obj => {
    return JSON.parse(JSON.stringify(obj));
};

export default {
    loginInfoKey,
    /**
     * 获取当前用户缓存
     *
     * @returns
     */
    getUser() {
        const userStr = Cookies.get('ce_user');
        const key = Cookies.get('ce_provider');
        if (userStr && key) {
            const decodeStr = CryptoJS.AES.decrypt(userStr, key).toString(CryptoJS.enc.Utf8);
            if (decodeStr) {
                if (!store.state.user.user) {
                    store.dispatch('user/setUser', JSON.parse(decodeStr));
                }
                return JSON.parse(decodeStr);
            }
        }
        return undefined;
    },
    /**
     * 总秒数转 ‘hh:mm:dd’ 字符串
     *
     * @param {*} value
     * @returns
     */
    secondsToTime(value) {
        value = Number(value);
        const hour = Math.floor(value / 3600);
        const minute = Math.floor((value - hour * 3600) / 60);
        const second = Math.floor(value - hour * 3600 - minute * 60);
        return `${toDoubleString(hour)}:${toDoubleString(minute)}:${toDoubleString(second)}`;
    },
    validatePhone,
    saveloginInfo,
    getloginInfo,
    decodePassword,
    showMsg,
    showOk,
    showError,
    filterProvince,
    clone
};
